<template>
  <header class="app-top-bar">
    <div class="top-bar-left">
      <!-- Intentionally sparse — org context only, no chrome floor -->
      <span v-if="organizationName" class="org-label">{{ organizationName }}</span>
    </div>
    <div class="top-bar-right">
      <div v-if="user" class="user-chip">
        <div class="user-text">
          <span class="user-name">{{ displayName }}</span>
          <span class="user-sep">/</span>
          <span class="user-role">{{ userRoleDisplay }}</span>
        </div>
        <div class="user-avatar" aria-hidden="true">
          <i class="fas fa-user-circle"></i>
        </div>
      </div>
      <button type="button" class="logout-link" @click="logout">
        Logout
      </button>
    </div>
  </header>
</template>

<script>
import auth from '@/services/auth';

export default {
  name: 'AppTopBar',
  data() {
    return {
      user: null,
    };
  },
  computed: {
    displayName() {
      if (!this.user) return '';
      const first = this.user.first_name || '';
      const last = this.user.last_name || '';
      const full = `${first} ${last}`.trim();
      return full || this.user.email || 'User';
    },
    organizationName() {
      return auth.getOrganizationName() || '';
    },
    userRoleDisplay() {
      const role = auth.getUserRole();
      const roleMap = {
        PLATFORM_ADMIN: 'Platform Admin',
        PLATFORM_ENGINEER: 'Platform Engineer',
        COMPLIANCE_OPS: 'Compliance Operations',
        ORG_ADMIN: 'Organization Admin',
        LMS_ADMIN: 'LMS Admin',
        COMPLIANCE_ADMIN: 'Compliance Admin',
        ANALYST: 'Analyst',
        LEARNER: 'Learner',
        SPEAKER: 'CE Speaker',
        VIEWER: 'Viewer',
        ADMIN: 'Admin',
        BUILDER: 'Builder',
      };
      return roleMap[role] || (role || '').replace(/_/g, ' ');
    },
  },
  created() {
    if (auth.isAuthenticated()) {
      this.user = auth.getUser();
    }
  },
  methods: {
    logout() {
      this.$router.push('/logout');
    },
  },
};
</script>

<style scoped>
.app-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 3.5rem;
  padding: 0 1.5rem;
  background: var(--p-surface-elevated, #ffffff);
  border-bottom: 1px solid var(--p-border, #e2e8f0);
  position: sticky;
  top: 0;
  z-index: 45;
}

.top-bar-left {
  min-width: 0;
  flex: 1;
}

.org-label {
  font-size: 0.875rem;
  color: var(--p-ink-muted, #64748b);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-bar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.user-chip {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.user-text {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  font-size: 0.875rem;
}

.user-name {
  font-weight: 600;
  color: var(--p-ink, #1e293b);
}

.user-sep {
  color: var(--p-ink-muted, #94a3b8);
}

.user-role {
  color: var(--p-ink-muted, #64748b);
}

.user-avatar {
  font-size: 1.75rem;
  color: var(--p-ink-muted, #64748b);
  line-height: 1;
}

.logout-link {
  border: none;
  background: transparent;
  color: var(--p-ink-muted, #64748b);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.25rem 0;
}

.logout-link:hover {
  color: #dc2626;
}

@media (max-width: 640px) {
  .user-role,
  .user-sep {
    display: none;
  }
  .org-label {
    display: none;
  }
}
</style>
